import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ServiciosService } from './servicios.service';
import { ClientesService } from './clientes.service';
import { ContactosService } from './contactos.service';
import { PagosService } from './pagos-service.service';
import { UsuariosPersonalService } from './usuarios-personal.service'
import {ConfirmacionesService} from "./confirmaciones.service";
import { CotizacionesService } from './cotizaciones.service';
@Injectable()
export class CSVService {

    // Contenido del CSV
    private csv:string;
    confirmacion:any;
    notaCambioServicio:any;

    viajes_arr_csv:any=[];

    constructor(
        private serviciosService:ServiciosService,
        private clienteService: ClientesService,
        private contactoService: ContactosService,
        private usuariosPersonalServices:UsuariosPersonalService,
        private pagosService:PagosService,
        private confirmacionesService: ConfirmacionesService,
        private clientesService: ClientesService,
        private cotizacionesService: CotizacionesService){}

    /**
     * Descarga un .csv con la información de la hoja de viajes
     * @param fechaInicial en formato de timestamp
     * @param fechaFinal en formato de timestamp
     */
    public descargarHojaDeViajes(fechaInicial:number, fechaFinal:number):Promise<any> {
        // Contenido del CSV
        return new Promise((resolve, reject) => {
            this.csv =
                'Id de Viaje,' + // Id de confirmación
                'Estatus,' + // Estatus de viaje
                'Tipo Venta,'+
                'Cliente,' + // Nombre de cliente
                'Contacto/Usuario,'+ // Nombre de "Contacto que Cotizó", si existe
                'Teléfono de Contacto,'+ // Nombre de "Contacto que Cotizó", si existe
                'Email de Contacto,'+ // Nombre de "Contacto que Cotizó", si existe
                'Contratante,'+ // COntacto con rol contratante en la confirmación
                'Coordinador,'+ // COntacto con rol coordinador en la confirmación
                'Unidades Solicitadas,'+ // Colocar el nombre del tipo de unidad separado por guiones (nodo de unidades solicitadas)
                'Tipos Unidades Solicitadas,'+ // Colocar el nombre del tipo de unidad separado por guiones (nodo de unidades solicitadas)
                'Numero de Pasajeros,' + // Cantidad de pasajeros
                'Tipo de Viaje,' + // Tipo de Viaje
                'Origen (Alias),' + // Alias de Origen
                'Destino (Alias),' + // Alias de Destino
                'Dirección (Origen),' + // Alias de Origen
                'Dirección (Destino),' + // Alias de Destino
                'Referencias (Origen),' + // Referencias de Origen
                'Referencias (Destino),' + // Referencias de Destino
                'Puntos Intermedios,' +
                'Inicio de Servicio,' + // Fecha en formato largo -> se logra con imprimir el valor de new Date(timestamp)
                'Fin de Servicio,' + // Fecha en formato largo -> se logra con imprimir el valor de new Date(timestamp)
                'Notas de Operador,' + // Notas del servicio
                'Costo de Servicio,' + // notas del viaje si es que las tiene
                'Notas de Cliente,' + // Indicaciones Especiales
                'Notas Cambios en Servicios,' + // Indicaciones Especiales
                'Kilometros Cotizados,' + // Indicaciones Especiales
                'Liquidada,' + // Total = montoPagado
                'Verificado,' + // Verificacion de servicio
                'Oficina de Origen,' + // Nombre de la oficina de origen seleccionada
                'Cliente Nuevo,' + // Si es la primera confirmacion del cliente
                'Especificaciones,' + // Si el servicio tiene especificaciones adjuntas
                '\n';

            let informacionViajes = '';

            this.serviciosService.obtenerServiciosEntreFechasCSV(fechaInicial, fechaFinal).get().then((viajes:any) => {
                let index=0
                this.viajes_arr_csv=[];
                if(viajes.size==0)
                {
                    reject(viajes.size)
                }

                this.cotizacionesService.traerInfoSistemaAdmin().take(1).subscribe(res => {
                    const oficinasDeOrigen = res as Array<any>;
                    const hashOficinas = {};
                    oficinasDeOrigen.forEach(oficina => {
                        hashOficinas[oficina.id_punto_origen] = oficina.nombre;
                    });
                
                    viajes.forEach((viaje, indice) => {
                        let tiposUnidadesSolicitadas = '';
                        this.obtenerDetalleViaje(viaje.data()).then((viajePromise)=>{
                            this.confirmacion = this.confirmacionesService.obtenerConfirmacion(viaje.data().confirmacion).valueChanges().take(1);
                            this.confirmacion.subscribe(confirmacion => {
                                this.notaCambioServicio = this.serviciosService.obtenerNotaCambioServicio(viaje.id).valueChanges().take(1);
                                this.notaCambioServicio.subscribe(notaCambio => {                                    
                                    if(confirmacion)
                                    {
                                        let precio = confirmacion.total;
    
                                        let indicacionesEspeciales = "";
                                        let kilometros_distancia = '';
                                        let verificacionVentas = 'No';
                                        let cantidadUnidades = 0;
    
                                        for (var idServicio in confirmacion.servicios) {
                                            indicacionesEspeciales+=confirmacion.servicios[idServicio].indicacionesEspeciales+" "
                                            kilometros_distancia = confirmacion.servicios[idServicio].parametros.kilometrosDeDistancia
                                        }
    
                                        for (var idUnidad in viaje.data().unidadesSolicitadas) {
                                            if(viaje.data().unidadesSolicitadas[idUnidad]>0)
                                            {
                                                tiposUnidadesSolicitadas += "("+viaje.data().unidadesSolicitadas[idUnidad]+") "+idUnidad+" "
                                            }
                                            cantidadUnidades +=viaje.data().unidadesSolicitadas[idUnidad]
                                        }
    
                                        let puntosIntermedios:string = '';
                                        if( viaje.data().puntosIntermedios){
                                            let contadorPuntosIntermedios:number = 1;
                                            for(let puntoIntermedioKey in  viaje.data().puntosIntermedios){
                                                puntosIntermedios += '(' + contadorPuntosIntermedios + ') - ' + this.limpiarString( viaje.data().puntosIntermedios[puntoIntermedioKey].direccion) + ' ';
                                                contadorPuntosIntermedios++;
                                            }
                                        }
    
                                        // Valida si el viaje es posible para colocar su ID
                                        let esViajePosible =  viaje.data().estatus == 'Posible';
                                        let idViaje;
                                        if(!esViajePosible)
                                            idViaje = ( viaje.data().idConfirmacion) ?  viaje.data().idConfirmacion : '';
                                        else
                                            idViaje = ( viaje.data().idCotizacion) ?  viaje.data().idCotizacion : '';
    
    
                                        var notasCambio = "SIN CAMBIOS";
                                        var notasCambio_arr = "";
                                        notaCambio.forEach(n_c => {
                                            if(n_c.nota)
                                            {
                                                var date = new Date(n_c.fecha);
                                                notasCambio_arr += n_c.nota + " - Hecho en: "+ date.toString()+". ";
                                            }
                                        });
                                        if(notasCambio_arr!="")
                                        {
                                            notasCambio = notasCambio_arr;
                                        }
    
                                        var refO = "";
                                        if(viaje.data().origen.referencias)
                                        {
                                            refO =    viaje.data().origen.referencias
                                        }
                                        var refD = "";
                                        if(viaje.data().destino.referencias)
                                        {
                                            refD =    viaje.data().destino.referencias
                                        }
    
                                        const confirmacionesTotales = esViajePosible ? viajePromise[4] : viajePromise[8];
                                        const tieneEspecificaciones = viaje.data().especificacionesHabilitadas ||
                                            (viaje.data().especificaciones && viaje.data().especificaciones.length > 0);

                                        var aux_viaje = {
                                            idViaje:this.limpiarString(idViaje),
                                            estatus:this.limpiarString( viaje.data().estatus),
                                            tipoVenta:this.limpiarString( viaje.data().tipoDeVenta[0]+viaje.data().tipoDeVenta[1]+viaje.data().tipoDeVenta[2]+viaje.data().tipoDeVenta[3]),
                                            cliente:this.limpiarString((viajePromise[0]) ? viajePromise[0] : ''),
                                            contacto:this.limpiarString((viajePromise[1]) ? viajePromise[1] : ''),
                                            telefono:this.limpiarString((viajePromise[2]) ? viajePromise[2] : ''),
                                            email:this.limpiarString((viajePromise[7]) ? viajePromise[7] : ''),
                                            contratante:this.limpiarString((viajePromise[3]) ? viajePromise[3] : ''),
                                            coordinador:this.limpiarString((viajePromise[5]) ? viajePromise[5] : ''),
                                            cantidadUnidades:cantidadUnidades,
                                            tiposUnidadesSolicitadas:tiposUnidadesSolicitadas,
                                            cantidadDePasajeros:viaje.data().cantidadDePasajeros,
                                            tipoDeViaje:this.limpiarString( viaje.data().tipoDeViaje),
                                            aliasOrigen:this.limpiarString( viaje.data().origen.alias),
                                            aliasDestino:this.limpiarString( viaje.data().destino.alias),
                                            dirOrigen:this.limpiarString( viaje.data().origen.direccion),
                                            dirDestino:this.limpiarString( viaje.data().destino.direccion),
                                            refOrigen:this.limpiarString(refO),
                                            refDestino:this.limpiarString(refD),
                                            puntosIntermedios:this.limpiarString(puntosIntermedios),
                                            inicioDeServicio:this.limpiarString(new Date( viaje.data().inicioDeServicio).toString()),
                                            finDeServicio:this.limpiarString(new Date( viaje.data().finDeServicio).toString()),
                                            notas:this.limpiarString(( viaje.data().notas) ?  viaje.data().notas : ''),
                                            precio:this.limpiarString(precio+"" ?  precio+"" : ""),
                                            indicacionesEspeciales:this.limpiarString(indicacionesEspeciales ?  indicacionesEspeciales : ""),
                                            notasCambio : this.limpiarString(notasCambio),
                                            kilometros_distancia:kilometros_distancia,
                                            liquidada: confirmacion.total == confirmacion.montoPagado ? 'Si' : 'No',
                                            verificacionVentas: viaje.data().verificacionVentas ? 'Sí' : 'No',
                                            oficinaDeOrigen: hashOficinas[viaje.data().oficinaDeOrigen],
                                            clienteNuevo: confirmacionesTotales == 1 ? 'Sí' : 'No',
                                            especificaciones: tieneEspecificaciones ? 'Sí' : 'No'
                                        }
                                        this.viajes_arr_csv.push(aux_viaje)
                                    }
    
                                    index++
                                    if(index == viajes.size)
                                    {
                                        this.crearCSV()
                                        resolve(true)
                                    }
                                })
                            });
                        })
                    });
                })

               
            });
        })
    }

    public descargarServiciosValidados(fechaInicial:number, fechaFinal:number):Promise<any> {
        // Contenido del CSV
        return new Promise((resolve, reject) => {
            this.csv =
                'Id de Viaje,' + // Id de confirmación
                'Estatus,' + // Estatus de viaje
                'Cliente,' + // Nombre de cliente
                'Inicio de Servicio,' + // Fecha en formato largo -> se logra con imprimir el valor de new Date(timestamp)
                'Fin de Servicio,' + // Fecha en formato largo -> se logra con imprimir el valor de new Date(timestamp)
                'Verificado,' + // Indicaciones Especiales
                '\n';

            this.serviciosService.obtenerServiciosEntreFechasCSV(fechaInicial, fechaFinal).get().then((viajes:any) => {
                let index=0
                console.log("viajes.size",viajes.size)
                if(viajes.size==0)
                {
                    reject(viajes.size)
                }

                viajes.forEach((viaje, indice) => {
                    this.obtenerDetalleViaje(viaje.data()).then((viajePromise)=>{
                        let idViaje =  viaje.data().idConfirmacion;
                        var aux_viaje = {
                            idViaje:this.limpiarString(idViaje),
                            estatus:this.limpiarString( viaje.data().estatus),
                            cliente:this.limpiarString((viajePromise[0]) ? viajePromise[0] : ''),
                            inicioDeServicio:this.limpiarString(new Date( viaje.data().inicioDeServicio).toString()),
                            finDeServicio:this.limpiarString(new Date( viaje.data().finDeServicio).toString()),
                            verificacionVentas:viaje.data().verificacionVentas
                        }
                        this.viajes_arr_csv.push(aux_viaje)

                        index++
                        if(index == viajes.size)
                        {
                            this.crearSV()
                            resolve(true)
                        }
                    })
                });
            });
        })
    }
    /**
     * Quita todas los caracteres que puedan ocasionar que el CSV salga mal
     * @param texto
     */
    private limpiarString(texto:string):string{
        return texto.toString().replace(/(\r\n\t|\n|\r\t)/gm,"").trim().replace(/,/g , " ");
    }

    private crearSV():void{

        this.viajes_arr_csv.sort(function(a, b){
            return (new Date(a.inicioDeServicio).getTime()) - (new Date(b.inicioDeServicio).getTime());
        });
        this.viajes_arr_csv.forEach((viaje, indice) => {
            let v = "No";
            if(viaje.verificacionVentas)
            {
                v="Sí"
            }
            this.csv +=
                viaje.idViaje+","+
                viaje.estatus+","+
                viaje.cliente+","+
                viaje.inicioDeServicio+","+
                viaje.finDeServicio+","+
                v+","+
                '\n'
        })

        console.log("Ya estoy creando el elemento de descarga de SV")
        var blob = new Blob(['\ufeff',this.csv],{"type":'text/csv;charset=utf-8;'});
        var urlScv = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.setAttribute("href",urlScv);
        link.setAttribute("download",'reporteServiciosValidados.csv');
        link.style.visibility='hiden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.csv = '';
    }
    private crearCSV(fileName = 'Hoja de Viajes.csv'):void{

        this.viajes_arr_csv.sort(function(a, b){
            return (new Date(a.inicioDeServicio).getTime()) - (new Date(b.inicioDeServicio).getTime());
        });

        this.viajes_arr_csv.forEach((viaje, indice) => {
            this.csv +=
                viaje.idViaje+","+
                viaje.estatus+","+
                viaje.tipoVenta+","+
                viaje.cliente+","+
                viaje.contacto+","+
                viaje.telefono+","+
                viaje.email+","+
                viaje.contratante+","+
                viaje.coordinador+","+
                viaje.cantidadUnidades+","+
                viaje.tiposUnidadesSolicitadas+","+
                viaje.cantidadDePasajeros+","+
                viaje.tipoDeViaje+","+
                viaje.aliasOrigen+","+
                viaje.aliasDestino+","+
                viaje.dirOrigen+","+
                viaje.dirDestino+","+
                viaje.refOrigen+","+
                viaje.refDestino+","+
                viaje.puntosIntermedios+","+
                viaje.inicioDeServicio+","+
                viaje.finDeServicio+","+
                viaje.notas+","+
                viaje.precio+","+
                viaje.indicacionesEspeciales+","+
                viaje.notasCambio+","+
                viaje.kilometros_distancia+","+
                viaje.liquidada+","+
                viaje.verificacionVentas+","+
                viaje.oficinaDeOrigen+","+
                viaje.clienteNuevo+","+
                viaje.especificaciones+","+
                '\n'

        })

        console.log("Ya estoy creando el elemento de descarga")
		var blob = new Blob(['\ufeff',this.csv],{"type":'text/csv;charset=utf-8;'});
		var urlScv = URL.createObjectURL(blob);
		var link = document.createElement("a");
		link.setAttribute("href",urlScv);
		link.setAttribute("download",fileName);
		link.style.visibility='hiden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		this.csv = '';
	}

    // Realiza una consulta del detalle de un viaje utilizando un observable envualado en un promise
	private obtenerDetalleViaje(servicio:any):Promise<any>{
		return new Promise((resolve, reject) => {
            let observables;
            if(servicio.estatus !== 'Posible'){
			    // Obtiene todos los campos que se van a colocar en el row de acuerdo a como está ordenado arriba
                observables = {
                    cliente : this.clienteService.obtenerPropiedadCliente(servicio.cliente, 'nombre').valueChanges(),
                    contacto : this.contactoService.obtenerPropiedadContacto(servicio.contactos.usuario,'nombre').valueChanges(),
                    telefono : this.contactoService.obtenerPropiedadContacto(servicio.contactos.usuario, 'telefono').valueChanges(),
                    contratante : this.contactoService.obtenerPropiedadContacto(servicio.contactos.contratante,'nombre').valueChanges(),
                    contratanteTel : this.contactoService.obtenerPropiedadContacto(servicio.contactos.contratante, 'telefono').valueChanges(),
                    coordinador : this.contactoService.obtenerPropiedadContacto(servicio.contactos.coordinador,'nombre').valueChanges(),
                    coordinadorTel : this.contactoService.obtenerPropiedadContacto(servicio.contactos.coordinador, 'telefono').valueChanges(),
                    contacto_email : this.contactoService.obtenerPropiedadContacto(servicio.contactos.usuario, 'email').valueChanges(),
                    confirmacionesTotales : this.clienteService.obtenerPropiedadCliente(servicio.cliente, 'confirmacionesTotales').valueChanges(),
                };
                Observable.zip(
                    observables.cliente,          // [0]
                    observables.contacto,         // [1]
                    observables.telefono,         // [2]
                    observables.contratante,      // [3]
                    observables.contratanteTel,   // [4]
                    observables.coordinador,      // [5]
                    observables.coordinadorTel,   // [6]
                    observables.contacto_email,   // [7]
                    observables.confirmacionesTotales // [8]
                )
                .subscribe(datos => resolve(datos));
            }else {
                observables={
                    cliente : this.clienteService.obtenerPropiedadCliente(servicio.cliente, 'nombre').valueChanges(),
                    contacto: this.contactoService.obtenerPropiedadContacto(servicio.contactoQueCotizo,'nombre').valueChanges(),
                    telefono: this.contactoService.obtenerPropiedadContacto(servicio.contactoQueCotizo, 'telefono').valueChanges(),
                    email: this.contactoService.obtenerPropiedadContacto(servicio.contactoQueCotizo, 'email').valueChanges(),
                    confirmacionesTotales: this.clienteService.obtenerPropiedadCliente(servicio.cliente, 'confirmacionesTotales').valueChanges(),
                }

                Observable.zip(
                    observables.cliente,              // [0]
                    observables.contacto,             // [1]
                    observables.telefono,             // [2]
                    observables.email,                // [3]
                    observables.confirmacionesTotales // [4]
                )
                .subscribe(datos => resolve(datos));
            }
		});
    }

    /**
     * Descarga un reporte de pagos programados dentro de las fechas proporcionadas ordenadas por id de viaje
     * @param fechaInicial
     * @param fechaFinal
     */
    public descargarReporteDePagosProgramados(fechaInicial, fechaFinal){
        this.pagosService.obtenerPagosEntreFechas(fechaInicial, fechaFinal).valueChanges().take(1)
        .map((pagos:any) => {
            // Ordena los pagos de por id de confirmación
            return pagos.sort(function(a,b){
                // Separa el ID de COnfirmación para sólo obtener el número
                let confirmacion1 = Number(a.confirmacionIdTrosten.split('-')[1]);
                let confirmacion2 = Number(b.confirmacionIdTrosten.split('-')[1]);
                return confirmacion1 - confirmacion2;
            });
        })
        // Realiza la configuración del CSV y manda la descarga del archivo
        .subscribe(pagos => {
            this.csv =
                'ID de Confirmación,' +
                'Estatus,' +
                'Fecha Programada,' +
                'Fecha de Pago,' +
                'Proceso de Pago,' +
                'Forma de Pago,' +
                'Referencia,' +
                'Total,' +
                'Aprobado por Finanzas,' +
                'Fecha subida de comprobante,' +
                '\n';

            // Introduce la información de cada pago en el CSV
            pagos.forEach(pago => {
                const fechaSubidaComprobante = new Date(pago.fechaSubidaComprobante)
                const fechaComprobante = fechaSubidaComprobante.getFullYear() + '-' + (fechaSubidaComprobante.getMonth() + 1) + '-' + fechaSubidaComprobante.getDate() + ' ' + fechaSubidaComprobante.getHours() + ':' + fechaSubidaComprobante.getMinutes() + ':' + fechaSubidaComprobante.getSeconds();

                this.csv +=
                pago.confirmacionIdTrosten + ',' +
                pago.estatus + ',' +
                new Date(pago.fechaProgramada).toLocaleDateString() + ',' +
                (pago.fechaDePago ? new Date(pago.fechaDePago).toLocaleDateString() : '') + ',' +
                pago.procesoDePago + ',' +
                pago.formaDePago + ',' +
                (pago.referencia ? pago.referencia : '') + ',' +
                pago.total + ',' +
                (pago.aprobacionFinanzas ? 'Si' : 'No') + ',' +
                fechaComprobante + ',' +
                '\n';
            });
            this.crearCSV();
        });
    }

    /**
     * Descarga un reporte de pagos realizados dentro de las fechas proporcionadas ordenadas por id de viaje
     * @param fechaInicial
     * @param fechaFinal
     */
   public descargarReporteDePagosrealizados(fechaInicial, fechaFinal) {
        this.pagosService.obtenerPagosEntreFechas(fechaInicial, fechaFinal, true).valueChanges().take(1)
        .map((pagos: any[]) => {
            return pagos.sort((a, b) => {
                let confirmacion1 = Number(a.confirmacionIdTrosten.split('-')[1]);
                let confirmacion2 = Number(b.confirmacionIdTrosten.split('-')[1]);
                return confirmacion1 - confirmacion2;
            });
        })
        .mergeMap((pagos) => {
            const pagosConInfo$ = pagos.map((pago) => {
                return this.confirmacionesService.obtenerConfirmacion(pago.confirmacion).valueChanges().take(1)
                .mergeMap((infoConfirmacion: any) => {
                    pago.infoConfirmacion = infoConfirmacion;

                    return this.clientesService.obtenerCliente(infoConfirmacion.cliente).valueChanges().take(1)
                    .mergeMap((infoCliente: any) => {
                        pago.infoCliente = infoCliente;

                        return this.serviciosService.obtenerServiciosDeConfirmacion(pago.confirmacion).valueChanges().take(1)
                        .map((servicios: any[]) => {
                            pago.infoServicio = servicios && servicios[0] ? servicios[0] : null;
                            return pago;
                        });
                    });
                });
            });

            return Observable.forkJoin(pagosConInfo$); // Wait for all to complete
        })
        .subscribe((pagosCompletos) => {

            console.log("pagosCompletos", pagosCompletos);
            // All pagos enriched — generate CSV
            this.csv =
                'Aprobado por Finanzas,' +
                'Fecha subida de comprobante,' +
                'ID de Confirmación,' +
                'Cliente,' +
                'Fecha de Servicio,' +
                'Fecha de Pago,' +
                'Proceso de Pago,' +
                'Forma de Pago,' +
                'ODC/Referencia,' +
                'Total,' +
                'Requiere Factura,' +
                'Folio de Factura,' +
                '\n';

            pagosCompletos.forEach((pago) => {
                const fechaSubidaComprobante = new Date(pago.fechaSubidaComprobante);
                const fechaComprobante = fechaSubidaComprobante.getFullYear() + '-' + (fechaSubidaComprobante.getMonth() + 1) + '-' + fechaSubidaComprobante.getDate() + ' ' + fechaSubidaComprobante.getHours() + ':' + fechaSubidaComprobante.getMinutes() + ':' + fechaSubidaComprobante.getSeconds();
                const fechaDeServicio = pago.infoServicio && pago.infoServicio.inicioDeServicio ? new Date(pago.infoServicio.inicioDeServicio) : null;
                const fechaDeServicioFormatted = fechaDeServicio ? fechaDeServicio.getFullYear() + '-' + (fechaDeServicio.getMonth() + 1) + '-' + fechaDeServicio.getDate() + ' ' + fechaDeServicio.getHours() + ':' + fechaDeServicio.getMinutes() + ':' + fechaDeServicio.getSeconds() : '';
                this.csv +=
                    (pago.aprobacionFinanzas ? 'Si' : 'No') + ',' +
                    fechaComprobante + ',' +
                    pago.confirmacionIdTrosten + ',' +
                    (pago.infoCliente.nombre || '') + ',' +
                    fechaDeServicioFormatted + ',' +
                    (pago.fechaDePago ? new Date(pago.fechaDePago).toLocaleDateString() : '') + ',' +
                    pago.procesoDePago + ',' +
                    pago.formaDePago + ',' +
                    (pago.formaDePago == 'Orden de Compra' ? pago.ordenCompra : pago.referencia) + ',' +
                    pago.total + ',' +
                    (pago.infoConfirmacion.requiereFactura ? 'Si' : 'No') + ',' +
                    (pago.folioFactura || '') + ',' +
                    '\n';
            });

            this.crearCSV('PagosPorRangoDeFechas.csv');
        });
    }


     public descargarReporteDeViajesConcluidos(listaViajes){

        console.log("listaViajes", listaViajes);
            this.csv =
                'ID de Confirmación,' +
                'Inicio,' +
                'Fin,' +
                'Origen,' +
                'Destino,' +
                'Operador,' +
                'Unidad,' +
                'Tipo,' +
                'Duración,' +
                'Otros Gastos,' +
                'Oficina,' +
                'Horas Cotizadas,' +
                '\n';

               
            listaViajes.forEach(viaje => {
                 const fechaInicio = new Date(viaje.horaInicio/1);
                const fechaInicioFormatted = fechaInicio.getFullYear() + '-' + (fechaInicio.getMonth() + 1) + '-' + fechaInicio.getDate() + ' ' + fechaInicio.getHours() + ':' + fechaInicio.getMinutes() + ':' + fechaInicio.getSeconds();
                const fechaFin = new Date(viaje.horaFin/1);
                const fechaFinFormatted = fechaFin.getFullYear() + '-' + (fechaFin.getMonth() + 1) + '-' + fechaFin.getDate() + ' ' + fechaFin.getHours() + ':' + fechaFin.getMinutes() + ':' + fechaFin.getSeconds();

                // escape origen and destino as they would probably include ,
                const origenEscaped = viaje.origen.replace(/,/g, ' ');
                const destinoEscaped = viaje.destino.replace(/,/g, ' ');
                const conceptosAdicionalesEscaped = viaje.otrosGastos.replace(/,/g, ' ');
                this.csv +=
                    viaje.idTrosten + ',' +
                    fechaInicioFormatted + ',' +
                    fechaFinFormatted + ',' +
                    origenEscaped + ',' +
                    destinoEscaped + ',' +
                    viaje.operador + ',' +
                    viaje.unidad + ',' +
                    viaje.tipoDeViaje + ',' +
                    viaje.duracion + ',' +
                    conceptosAdicionalesEscaped + ',' +
                    viaje.oficina + ',' +
                    viaje.horasCotizadas + ',' +
                '\n';
            });
            this.crearCSV("ViajesConcluidos.csv");
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/csv.service.ts